import { useTranslations } from '@vocab/react';
import { Text, Badge, Stack, Box, List } from 'braid-design-system';
import type React from 'react';
import { useEffect, useState } from 'react';

import translations from '@seek/rr-caja/src/.vocab';

import type { Question } from '../../sdk';
import { AlertPanel } from '../AlertPanel/AlertPanel';
import LoaderPanel from '../LoaderPanel/LoaderPanel';

type Props = {
  fetchedQuestions: Question[];
  fetchQuestionnaireState: 'loading' | 'error' | 'questions';
};

export const ReadOnlyQuestions: React.FunctionComponent<Props> = ({
  fetchedQuestions,
  fetchQuestionnaireState,
}) => {
  const { t } = useTranslations(translations);
  const [questions, setQuestions] = useState<Question[]>([]);
  const [state, setState] = useState<'loading' | 'error' | 'questions'>(
    'loading',
  );

  useEffect(() => {
    setQuestions(fetchedQuestions);
    setState(fetchQuestionnaireState);
  }, [fetchedQuestions, fetchQuestionnaireState]);

  switch (state) {
    case 'error':
      return <AlertPanel />;
    case 'loading':
      return <LoaderPanel isLoading={true} />;
    case 'questions':
      return (
        <Box padding="small">
          <List space="large">
            {questions.map((question) => (
              <Stack space="small" key={question.id}>
                {question.essential && <Badge>{t('mustHave.badge')}</Badge>}
                <Text data={{ testid: 'read_only_question_text' }}>
                  {question.text}
                </Text>
              </Stack>
            ))}
          </List>
        </Box>
      );
  }
};
